import { useParams } from "react-router-dom";

import { FlexPackDetailsWrapper } from "../../components";

export default function FlexPackDetailsPage() {
  const { uuid } = useParams();
  return (
    <>
      <FlexPackDetailsWrapper flexPackId={uuid} />
    </>
  );
}
